/* eslint-disable no-console */
/* eslint-disable react/no-multi-comp */
/* eslint-disable max-len */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import { FormattedMessage } from 'react-intl';
import {
    CardNumberElement,
    CardExpiryElement,
    CardCVCElement,
    StripeProvider,
    Elements,
    injectStripe
} from 'react-stripe-elements';
import moment from 'utils/moment';
import styles from './step2.module.scss';
import btnStyles from '../../../../components/button/button.module.scss';
import { getStripeKey } from '../../../../utils/helpers';

const createOptions = () => ({
    style: {
        base: {
            fontSize: '16px',
            color: '#424770',
            fontFamily: 'Open Sans, sans-serif',
            letterSpacing: '0.025em',
            border: '1px solid red',
            '::placeholder': {
                color: '#aab7c4'
            }
        },
        invalid: {
            color: '#c23d4b'
        }
    }
});

class _CardForm extends Component {
    state = {
        card_error_msg: undefined,
        card_expiry_error_msg: undefined,
        card_cvv_error_msg: undefined
    };

    componentDidMount() {
        const { onRef } =this.props;
        onRef(this);
    }

    componentWillUnmount() {
        const { onRef } =this.props;
        onRef(undefined);
    }

    handleSubmit = (ev) => {
        const { card_error_msg, card_expiry_error_msg, card_cvv_error_msg } = this.state;
        const { stripe, enableLoadingStatus, doPayment } = this.props;
        ev.preventDefault();
        if (stripe) {
            enableLoadingStatus();
            stripe.createToken().then((payload) => {
                doPayment(payload, card_error_msg, card_expiry_error_msg, card_cvv_error_msg);
            });
        } else {
            console.log("Stripe.js hasn't loaded yet.");
        }
    };

    handleChange = (change) => {
        if (change.elementType === "'cardNumber'" && !change.complete) {
            this.setState({
                card_error_msg: 'Please enter card number.'
            });
        } else if (change.elementType === 'cardNumber' && change.complete) {
            this.setState({
                card_error_msg: ''
            });
        }
        if (change.elementType === 'cardExpiry' && !change.complete) {
            this.setState({
                card_expiry_error_msg: 'Please enter card expiry date.'
            });
        } else if (change.elementType === 'cardExpiry' && change.complete) {
            this.setState({
                card_expiry_error_msg: ''
            });
        }
        if (change.elementType === 'cardCvc' && !change.complete) {
            this.setState({
                card_cvv_error_msg: 'Please enter card cvv.'
            });
        } else if (change.elementType === 'cardCvc' && change.complete) {
            this.setState({
                card_cvv_error_msg: ''
            });
        }
    };

    render() {
        const { card_error_msg, card_expiry_error_msg, card_cvv_error_msg } = this.state;
        return (
            <div>
                <form onSubmit={this.handleSubmit} id="paymentForm">
                    <div className={styles.inputDetails}>
                        <div className={styles.detailField} style={{ padding: '5px 15px' }}>
                            <FormattedMessage
                                id={'invoice.payment.card_number'}
                                defaultMessage={'Card Number'}
                            />
                            <CardNumberElement
                                onChange={this.handleChange}
                                {...createOptions()}
                                className={styles.StripeElement}
                            />
                            <span style={{ color: 'red' }}>{card_error_msg}</span>
                        </div>
                        <div className={styles.detailField} style={{ padding: '5px 15px' }}>
                            <FormattedMessage
                                id={'invoice.payment.card_expiry_date'}
                                defaultMessage={'Expiration date'}
                            />
                            <CardExpiryElement
                                onChange={this.handleChange}
                                {...createOptions()}
                                className={styles.StripeElement}
                            />
                            <span style={{ color: 'red' }}>
                                {card_expiry_error_msg}
                            </span>
                        </div>
                        <div className={styles.detailField} style={{ padding: '5px 15px' }}>
                            <FormattedMessage
                                id={'invoice.payment.card_cvv'}
                                defaultMessage={'CVV'}
                            />
                            <CardCVCElement
                                onChange={this.handleChange}
                                {...createOptions()}
                                className={styles.StripeElement}
                            />
                            <span style={{ color: 'red' }}>
                                {card_cvv_error_msg}
                            </span>
                        </div>
                    </div>
                </form>
                <div style={{ float: 'right', top: '200px', position: 'relative' }}>
                    <button form="paymentForm" type="submit" className={`${btnStyles.button} ${btnStyles.secondary} ${'float-center mt-2 mb-2 mr-4'}`}>
                        <FormattedMessage id={'wildlife.form.1'} defaultMessage={'Submit'} />
                    </button>
                </div>
            </div>
        );
    }
}

const CardForm = injectStripe(_CardForm);

class Step2 extends Component {
    doPayment = (tokenDetails, cardNumber, expiryDate, cvvNumber) => {
        const { schemaSettings, handlePayment } = this.props;
        const sendResponse = {};
        if (tokenDetails && cardNumber==='' && expiryDate==='' && cvvNumber==='') {
          sendResponse.tokenDetails = tokenDetails;
          sendResponse.amount = schemaSettings?.settings?.badge_fee;
          sendResponse.description = `badge ${schemaSettings.schema.id} - ${schemaSettings?.settings?.badge_fee} - ${moment().format()}`;
          sendResponse.badgeId = schemaSettings.schema.id;
          sendResponse.payment_date = moment().format();
          sendResponse.payment_method = 'credit_card';
          handlePayment(sendResponse);
        }
      };

    render() {
        const { schemaSettings, profileCurrency, airportSettings } = this.props;
        const stripeKey = getStripeKey(airportSettings);

        return (
            <div>
                <div className={`container ${styles.form}`}>
                    <h5 style={{ fontWeight: 'bold', color: '#242e42', padding: '0px 38px', marginBottom: '0px' }}>Badge Fees</h5>
                    <div className={`${styles.content} ${styles.embedded}`}>
                        <div className={styles.detailsWrapper}>
                            <div
                                className={styles.detailsSection}
                                style={{ margin: '0px', paddingBottom: '0px' }}
                            >
                                <div className={styles.selectedCust}>
                                    <div>
                                        <span className={styles.billTo}>
                                            <FormattedMessage
                                                id="invoices_payment.title"
                                                defaultMessage="Pay by card"
                                            />
                                        </span>
                                    </div>
                                </div>
                                <div className={styles.fvz}>
                                    <span className={styles.billTo}>
                                        <NumberFormat
                                            displayType="text"
                                            value={`${schemaSettings?.settings?.badge_fee}.00`}
                                            thousandSeparator
                                            prefix={profileCurrency}
                                        />
                                    </span>
                                </div>
                            </div>
                            <hr style={{ width: '837px', alignSelf: 'center' }} />
                            <div className={styles.billDetailsWrapper}>
                                <StripeProvider apiKey={stripeKey}>
                                    <Elements>
                                        <CardForm
                                            doPayment={(tokenDetails, cardNumber, expiryDate, cvvNumber) => this.doPayment(tokenDetails, cardNumber, expiryDate, cvvNumber)}
                                            onRef={(ref) => { this.child = ref; }}
                                            enableLoadingStatus={() => {
                                                this.setState({ loadingStatus: true });
                                            }}
                                        />
                                    </Elements>
                                </StripeProvider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Step2;
